<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Usuários', 'link' : '/users' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Cadastrar Usuário</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Usuário</h1>
    <!-- Div Formulario -->
    <form class="row" v-if="!loading" @submit.prevent="actionOperation" @keydown.enter.prevent>
      <div class="col-2"></div>
      <div class="col-12 col-md-8" >
        <div class="row">
          <div class="row m-0 p-0">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label for="newUserName">Nome:</label>
                <input required v-model="usermodel.name" name="newUserName" type="text" class="form-control" id="newUserName" placeholder="">
              </div>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newUserEMAIL">E-mail:</label>
                <input v-model="usermodel.email" type="text" class="form-control" id="newUserEMAIL" name="newUserEMAIL" placeholder="">
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newUserWhatsapp">Whatsapp:</label>
                <input v-model="usermodel.phone" type="text" class="form-control" id="newUserWhatsapp" name="newUserWhatsapp" placeholder="" />
              </div>
            </div>
            <div class="col-md col-sm-12 mt-2 form-group">
              <label for="inpTxtUserLevel">Level:</label>
              <select v-model="usermodel.level" required class="form-control" name="inpTxtUserLevel" id="inpTxtUserLevel">
                <option value="" disabled selected>Selecione o Level</option>
                <option v-for="level in levelslist" :value="level.value" :key="level.value">
                  {{ level.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientDate">Data de Aniversário:</label>
              <input v-model="usermodel.birthdate" type="date" class="form-control" id="newClientDate" name="newClientDate" placeholder="">
            </div>
          </div>
          <div class="row mt-2 m-0 p-0">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label v-show="operation == 'store'" for="newClientPass">Senha:</label>
                <label v-show="operation == 'update'" for="newClientPass">Nova Senha:</label>
                <input :required="operation === 'store'" v-model="usermodel.password" name="newClientPass" type="password" class="form-control" id="newClientPass" placeholder="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/users">
            Voltar
          </router-link>
          <button type="submit" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button @click="clearForm" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
      <div style="height: 90px;"></div>
    </form>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados do usuário...</p>
        <p class="mt-2" v-else-if="loading">Salvando usuário...</p>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { users } from '@/models/users';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import states from '@/services/states.js';
import { useRouter } from 'vue-router';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import { useAuth } from '@/services/auth';

export default {
  name: "NewClientView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = users();
    const getstates = states.get();
    const stateslist = getstates;
    const router = useRouter();
    const auth = useAuth();

    const usermodel = reactive({
      name : null,
      email : null,
      phone : null,
      birthdate : null,
      level : null,
      password : null,
      id_tenant : auth.tenant.id
    });

    const levelslist = [
      { value: 'adm', name: 'Administrador' },
      { value: 'user', name: 'Usuário' },
      { value: 'operador', name: 'Operador' }
    ];

    onMounted(() => {
      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = "Atualizar Usuário - LC3 Locações";

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          usermodel.id = response.id;
          usermodel.name = response.name;
          usermodel.email = response.email;
          usermodel.phone = response.phone;
          usermodel.birthdate = response.birthdate;

          switch (response.tenant.rule) {
            case 0:
              usermodel.level = 'adm';
              break;
            case 1:
              usermodel.level = 'user';
              break;
            case 2:
              usermodel.level = 'operador';
              break;
            default:
              usermodel.level = 'operador';
          }

          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar usuário: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        if (!usermodel.name) {
          toastStore.warning('O nome é obrigatório.');
          return;
        }
        store();
      }
    }

    function store() {
      loading.value = true;
      model.store(usermodel).then(() => {
        toastStore.success('Usuário cadastrado com sucesso!');
        loading.value = false;
        router.push('/users');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao cadastrar usuário: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(usermodel).then(() => {
        toastStore.success('Usuário atualizado com sucesso!');
        router.push('/users');
        loading.value = false;
      }).catch((error) => {
        toastStore.error('Erro ao atualizar usuário: ' + parseError(error));
        loading.value = false;
      });
    }

    return {
      stateslist,
      usermodel,
      actionOperation,
      operation,
      loading,
      levelslist
    }

  }
}
</script>